(function () {

    'use strict';

    angular
        .module('app.core')
        .service('GaService', [
            'API_CONFIG',
            '$location',
            '$timeout',
            GaService
        ]);

    function GaService(API_CONFIG, $location, $timeout) {
        var service = this;

        service.gaLoadScript = gaLoadScript;
        service.gaTrackClickFromLinks = gaTrackClickFromLinks;
        service.gaTrackPageViewAsync = gaTrackPageViewAsync;

        function getGATrackerNumber() {
            return API_CONFIG.google.GOOGLE_ANALYTICS_TRACK_NUM;
        }

        function gaLoadScript() {
            $timeout(
                function() {
                    (function (i, s, o, g, r, a, m) {
                        i['GoogleAnalyticsObject'] = r;
                        i[r] = i[r] || function () {
                                (i[r].q = i[r].q || []).push(arguments)
                            }, i[r].l = 1 * new Date();
                        a = s.createElement(o),
                            m = s.getElementsByTagName(o)[s.getElementsByTagName(o).length - 1];
                        a.async = 1;
                        a.src = g;
                        //m.parentNode.insertBefore(a, m);
                        m.parentNode.insertBefore(a, m.nextSibling);
                    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
                }
            , 0);
        }

        function gaTrackPageViewAsync(url, title) {
            if (typeof getGATrackerNumber != 'function') {
                return;
            }

            window.ga = window.ga || [];
            if (typeof window.ga != 'function') {
                return;
            }

            window.ga('create', getGATrackerNumber(), 'none', {
                'allowLinker': true
            });

            if (title !== undefined) {
                window.ga('set', 'title', title);
            }

            if (url !== undefined) {
                window.ga('send', 'pageview', url);
            }
            else if (typeof gaTrackPageViewCustomUrl === 'function') {
                window.ga('send', 'pageview', gaTrackPageViewCustomUrl());
            }
            else {
                window.ga('send', 'pageview');
            }
        }

        function gaTrackPageViewCustomUrl() {
            return $location.path();
        }

        function gaTrackClickFromLinks(pageName, linkName,url) {
            if (typeof getGATrackerNumber != 'function') {
                return;
            }

            window.ga = window.ga || [];

            if (typeof window.ga != 'function') {
                return;
            }

            window.ga('create', getGATrackerNumber(), 'none', {
                'allowLinker': true
            });

            if (!isUndefinedOrNull(url)) {
                window.ga('set', 'location',
                    (linkName == "View Vehicle Details" ? url.substring(2, url.lastIndexOf("/")) : url.substring(2)));
            } else {
                window.ga('set', 'location', gaTrackPageViewCustomUrl());
            }


            window.ga('send', 'event', pageName, 'clicked', linkName);
        }
    }

})();


// WEBPACK FOOTER //
// ./app/core/service/GaService.js